export default "__VITE_ASSET__DEy4Rdty__"